import { BFLType } from "../types/DBTables";

export function checkOrganisationNumber(nr: string) {
  let valid = false;
  if (!nr.match(/^(\d{1})(\d{5})-(\d{4})$/)) {
    return false;
  }
  let group = RegExp.$1;
  let controldigits = RegExp.$3;
  let alldigits = group + RegExp.$2 + controldigits;
  if (alldigits.substring(2, 3) < "2") {
    return false;
  }
  let nn = "";
  for (let n = 0; n < alldigits.length; n++) {
    nn += (((n + 1) % 2) + 1) * Number(alldigits.substring(n, n + 1));
  }
  let checksum = 0;
  for (let n = 0; n < nn.length; n++) {
    checksum += Number(nn.substring(n, n + 1));
  }
  valid = checksum % 10 === 0 ? true : false;

  return valid;
}

export const numFrmtStd = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1, useGrouping: true });
export const numFrmt0Dec = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0, useGrouping: true });
export const numFrmt1Dec = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1, minimumFractionDigits: 1, useGrouping: true });
export const numFrmt2Dec = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: true });
export const numFrmt3Dec = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 3, minimumFractionDigits: 3, useGrouping: true });

///Formats a string with placeholders like "Hello {name}, today is your {luckValue} day", with obj being an object containg the values.
export function formatString(str: string, obj: any) {
  return str.replace(/{\S*?}/g, function (m) {
    var n = m.replace("{", "").replace("}", "");
    var v = obj[n];
    if (v === undefined) v = "!" + n + "!";
    return v;
  });
}

export function delayAsync(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

//Formats a string with placeholders like "Hello {name}, today is your {luckValue} day", with fn being a function returning the values.
export function formatStringFn(str: string, fn: (varName: string) => any) {
  return str.replace(/{\S*?}/g, function (m) {
    var n = m.replace("{", "").replace("}", "");
    var v = fn(n);
    return v;
  });
}

export const bfKeyForHelp: Record<BFLType, string> = {
  BFK_J1: "BFKJ1",
  BFL_J3_FTX_FT: "BFLJ3FTX",
  BFL_J3_FX_F: "BFLJ3FX",
  BFL_J4_FTX: "BFLJ4FTX",
  BFL_J5_FTX_FT: "BFLJ5FTX",
  BFV_J10: "BFV_J10",
  BFV_J11: "BFVJ11",
  BFV_J12: "BFVJ12",
  BFV_J13: "BFV_J13",
  BFV_J3: "BFV_J3",
  BFV_J4: "BFV_J4",
  BFV_J5: "BFV_J5",
  BFV_J6: "BFVJ6",
  BFV_J8: "BFV_J8",
  BFV_J9: "BFV_J9",

  BFL_J3_S: "BFLJ3S", //Inga texter?
  Unknown: "Unknown",
  NotYetImplemented: "NotYetImplemented",
};

export const getRoleName = (roleName: string) => {
  switch (roleName) {
    case "Admin":
      return "Global systemadministratör";
    case "UserAdmin":
      return "Administratör (användare/abonnemang)";
    case "Buildings":
      return "Byggnader";
    case "Round":
      return "Rondering";
    case "Configuration":
      return "Konfigurering byggnader";
    default:
      return "? : " + roleName;
  }
};

export const getRoleOrder = (roleName: string) => {
  switch (roleName) {
    case "Admin":
      return "01";
    case "UserAdmin":
      return "02";
    case "Buildings":
      return "03";
    case "Configuration":
      return "04";
    case "Round":
      return "05";
    default:
      return "99";
  }
};

function base64ToBlob(base64: any, mime: any) {
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

export function showPDFFromBase64(pdfBase64: string) {
  const pdfBlob = base64ToBlob(pdfBase64, "application/pdf");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  const win = window.open(pdfUrl, "_blank");
  if (!win) {
    // Fallback: open in the current tab
    window.location.href = pdfUrl;
  }
}
